module.exports = __webpack_public_path__ + "img/aialgorithm.3ae892d1.png";